import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify'
import { AgentApi } from '@/domains/agent/apis'
import type { UploadResponse } from '@/types/upload'
import type { AgentUploadConfig, AgentUploadParams, AgentUploadStrategy } from './agent-upload-strategy'
import { BaseAgentUploadStrategy } from './base-agent-upload-strategy'

@injectable()
export class LcaAgentUploadStrategy implements AgentUploadStrategy {
    constructor(
        @inject(BaseAgentUploadStrategy) private _baseAgentUploadStrategy: BaseAgentUploadStrategy,
        @inject(AgentApi) private _agentApi: AgentApi
    ) {}

    async getLimit(): Promise<number> {
        return 1
    }

    getUploadConfig(): AgentUploadConfig {
        return {
            sizeLimit: 25 * 1024 * 1024,
            accept: '.pdf,.jpg,.jpeg,.png',
        }
    }

    async upload(params: AgentUploadParams): Promise<UploadResponse | undefined> {
        const normalizedParams = this._baseAgentUploadStrategy.normalizeParams(params)
        const data = await this._agentApi.uploadFileForSpecialAgent(
            { file: normalizedParams.file },
            event => this._baseAgentUploadStrategy.reportProgress(event, normalizedParams.onProgress)
        )
        return this._baseAgentUploadStrategy.createSuccessResponse(data)
    }
}
